/**
 * Web Viewport Implementation
 */

// iPadOS reports a desktop Mac user agent by default; touch support tells it apart.
const isAppleTouchDevice = (): boolean =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);

/**
 * Stop iOS zooming into a focused input whose text is under 16px.
 *
 * Every iOS browser (all WebKit) zooms in on focus and stays zoomed after the
 * keyboard closes, leaving the page clipped. `maximum-scale=1` turns that off.
 * iOS ignores it for pinch zoom, so people can still zoom; Android browsers
 * honour it and would lose pinch zoom, so it's only added on Apple touch devices.
 */
export const preventIosInputZoom = (): void => {
  if (!isAppleTouchDevice()) return;

  const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta || meta.content.includes("maximum-scale")) return;

  meta.content = `${meta.content}, maximum-scale=1`;
};
